import React from "react";
import About from "./About";
import Contact from "./Contact";
import Footer from "./Footer";
import LandinPage from "./LandinPage";
import Projects from "./Projects";
import Skills from "./Skills";




const Home = ({ currentTheme, themeToggler }) => {
    
    return (
      <div>
      
        <LandinPage />
        <About />
        <Skills />
        <Projects />
        <Contact />
        <Footer />
      </div>
    );
};

export default Home;
